/**
 * useScreenTTI — screen time-to-interactive telemetry hook.
 *
 * Emits `performance.mark("screen_tti_<name>")` exactly once on first ready
 * render. Safe to call unconditionally at the top of every screen component;
 * the `enabled` flag gates whether the mark fires.
 *
 * @see PRD § 7.3 for the canonical contract.
 * @see FR-020 for the requirement.
 */
import { useEffect, useRef } from "react";

export function useScreenTTI(
  name: string,
  options: { enabled?: boolean } = {},
): void {
  const { enabled = true } = options;
  const marked = useRef(false);

  useEffect(() => {
    if (enabled && !marked.current) {
      performance.mark(`screen_tti_${name}`);
      marked.current = true;
    }
  }, [enabled, name]);
}
